import React, { useCallback, useMemo, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import SydButton from '../../../commonDesign/Button'
import SydModal from '../../../commonDesign/SydModal'
import SnackAlert from '../../../molecules/SnackAlert/SnackAlert'
import { useEntityGraphContext } from '../Wrapper/EntityGraphProvider'
import { useSaveEntityGraph } from '../../../../api/entityGraphs'
import SydModalActions from '../../../commonDesign/SydModal/SydModalActions'

const useStyles = makeStyles({
  container: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    padding: 'var(--padding-md)',
    display: 'flex',
    gap: '1rem'
  }
})

export const SaveControls = () => {
  const classes = useStyles()
  const [showResetConfirm, setShowResetConfirm] = useState(false)
  const [alert, setAlert] = useState(null)

  const { state } = useEntityGraphContext()
  const stateHasChanged = useMemo(() => state?.stateHasChanged || false, [state])

  const mutation = useSaveEntityGraph()
  const onSave = useCallback(async () => {
    try {
      await mutation.mutateAsync({
        data: state.data,
        config: state.config,
        entityGraphId: state.entityGraphId ?? undefined,
        graphType: state.graphType,
        levelTypes: [{
          levelTypeId: state.levelTypeId,
          levelId: state.levelId
        }]
      })
      setAlert({ alertMessage: 'Changes saved successfully!', alertSeverity: 'success' })
    } catch (error) {
      setAlert({ alertMessage: 'Failed to save changes', alertSeverity: 'error' })
    }

    setTimeout(() => {
      setAlert(null)
    }, 5000)
  }, [mutation, state])

  return (
    <>
      <SydModal
        open={showResetConfirm}
        onClose={() => setShowResetConfirm(false)}
        title='Are you sure?'
        subtitle='Are you sure you want to reset the settings? This action cannot be undone.'
      >
        <SydModalActions>
          <SydButton
            variant='secondary'
            onClick={() => setShowResetConfirm(false)}
          >
            Cancel
          </SydButton>
          <SydButton
            variant='primary'
            onClick={() => {
              // Reset logic here
              setShowResetConfirm(false)
              setAlert('Settings reset successfully!')
            }}
          >
            Confirm Reset
          </SydButton>
        </SydModalActions>
      </SydModal>
      {alert?.alertMessage?.length && (
        <SnackAlert alert={{ ...alert, openAlert: true }} />
      )}
      <div className={classes.container}>
        <SydButton
          variant='secondary'
          onClick={() => setShowResetConfirm(true)}
          disabled={mutation.isPending || !stateHasChanged}
        >
          Reset
        </SydButton>
        <SydButton variant='primary' onClick={onSave} disabled={mutation.isLoading} processing={mutation.isLoading}>
          {mutation.isLoading ? 'Saving Changes...' : 'Save Changes'}
        </SydButton>
      </div>
    </>
  )
}
